import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import WarningModal from 'components/WarningModal';
import TutorialModal from 'components/TutorialModal';
import { LIMITED_ROUTES, routes } from 'constants/routes';
import Layout from 'layout';
import ProtectedRoute from 'routers/ProtectedRoute';
import routerDefinitions from 'routers/routers';

type Props = {
  isAgeConfirmed: boolean;
  isLimited?: boolean;
  loading?: boolean;
  onConfirm: () => void;
};

function AgeGatedRoutes({
  isAgeConfirmed,
  isLimited = false,
  loading = false,
  onConfirm,
}: Props) {
  const location = useLocation();
  const searchRedirect = (
    <Navigate
      to={{
        pathname: routes.SEARCH,
        search: location.search,
        hash: location.hash,
      }}
      state={location.state}
      replace
    />
  );

  if (!isAgeConfirmed && location.pathname === '/') {
    return searchRedirect;
  }

  return (
    <>
      {!isAgeConfirmed ? (
        <WarningModal onConfirm={onConfirm} />
      ) : (
        <Routes>
          <Route element={<Layout loading={loading} />}>
            <Route path="/" element={searchRedirect} />
            {routerDefinitions
              .filter((route) =>
                isLimited ? !LIMITED_ROUTES.includes(route.path) : true,
              )
              .map(
                ({
                  path,
                  component: PageComponent,
                  isProtected,
                  children,
                }) => (
                  <Route
                    key={path}
                    path={path}
                    element={
                      isProtected ? (
                        <ProtectedRoute>
                          <PageComponent />
                        </ProtectedRoute>
                      ) : (
                        <PageComponent />
                      )
                    }
                  >
                    {children?.map((child) => {
                      const ChildComponent = child.component;
                      return (
                        <Route
                          key={child.path}
                          path={child.path}
                          element={<ChildComponent />}
                          index={child.index}
                        />
                      );
                    })}
                  </Route>
                ),
              )}
          </Route>
        </Routes>
      )}
      <TutorialModal />
    </>
  );
}

export default AgeGatedRoutes;
